<template>
  <div class="kircWrapper" id="kirc">
    <!-- Particle bg -->
    <div class="particles"></div>
    <div class="md-layout md-alignment-top-center">
      <div class="
                            md-layout-item
                            md-size-80
                            md-medium-size-95
                            md-small-size-95
                            md-xsmall-size-100
                          ">
        <!-- Hash Input -->
        <md-card v-if="!showComparison()">
          <md-card-content>
            <div class="md-layout" :class="'md-alignment-top-center'">
              <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100" :class="'md-alignment-top-center'">
                <div class="headlineWrapper">
                  <div class="md-display-1 mainHeadline">
                    Hier alten Ergebniscode eingeben:
                  </div>
                </div>
                <md-field>
                  <label>KI-Readiness-Check Ergebniscode</label>
                  <md-input v-model="oldHash"></md-input>
                </md-field>
              </div>
            </div>
          </md-card-content>
          <md-card-actions>
            <md-button to="" @click="loadKIRCData()" class="md-raised md-primary CTA CTA--Main">
              <span class="buttonText">Ergebnis laden</span>
            </md-button>
          </md-card-actions>
          <h4 v-if="error === 'new'">
            Der Ergebniscode in Ihrem Link ist ungültig. Bitte führen Sie den KIRC erneut durch.
          </h4>
          <h4 v-if="error === 'old'">
            Dieser Ergebniscode ist uns nicht bekannt. Bitte geben Sie einen gültigen Ergebniscode an.
          </h4>
        </md-card>
        <!-- Comparison Area -->
        <md-card style="max-width: 70%;" class="mainFormCard md-elevation-16" v-if="showComparison()">
          <md-card-header>
            <div class="headlineWrapper">
              <div class="md-layout">
                <div class="md-layout-item md-size-50">
                  <div class="md-display-2 mainHeadline">
                    Neuer KIRC
                  </div>
                </div>
                <div align="right" class="md-layout-item md-size-50">
                  <div class="md-display-2 mainHeadline">
                    Alter KIRC
                  </div>
                </div>
              </div>
            </div>
          </md-card-header>
          <md-card-content>
            <div style="display: flex; justify-content: space-evenly;">
              <md-card class="CustomCard">
                <md-card-content>
                  <div style="position: relative;">
                    <md-progress-spinner align="center" :md-diameter="250" :md-stroke="30" md-mode="determinate" :md-value="newData.score * 0.2967359050445103857566765578635"></md-progress-spinner>
                    <div class="finalScoreWrapper">
                      <h4 class="levelSubheading">Level</h4>
                      <h1 id="finalScore" class="mb-2">
                        {{ Math.ceil(newData.score / 68) + "/5" }}
                      </h1>
                      <h1 slot="textCard__Headline" v-if="Math.ceil(newData.score / 68) === 1">
                        {{ level1.name }}
                      </h1>
                      <h1 slot="textCard__Headline" v-if="Math.ceil(newData.score / 68) === 2">
                        {{ level2.name }}
                      </h1>
                      <h1 slot="textCard__Headline" v-if="Math.ceil(newData.score / 68) === 3">
                        {{ level3.name }}
                      </h1>
                      <h1 slot="textCard__Headline" v-if="Math.ceil(newData.score / 68) === 4">
                        {{ level4.name }}
                      </h1>
                      <h1 slot="textCard__Headline" v-if="Math.ceil(newData.score / 68) === 5">
                        {{ level5.name }}
                      </h1>
                    </div>
                  </div>
                </md-card-content>
              </md-card>
              <md-card class="CustomCard">
                <md-card-content>
                  <div style="position: relative;">
                    <md-progress-spinner align="center" :md-diameter="250" :md-stroke="30" md-mode="determinate" :md-value="oldData.score * 0.2967359050445103857566765578635"></md-progress-spinner>
                    <div class="finalScoreWrapper">
                      <h4 class="levelSubheading">Level</h4>
                      <h1 id="finalScore" class="mb-2">
                        {{ Math.ceil(oldData.score / 68) + "/5" }}
                      </h1>
                      <h1 slot="textCard__Headline" v-if="Math.ceil(oldData.score / 68) === 1">
                        {{ level1.name }}
                      </h1>
                      <h1 slot="textCard__Headline" v-if="Math.ceil(oldData.score / 68) === 2">
                        {{ level2.name }}
                      </h1>
                      <h1 slot="textCard__Headline" v-if="Math.ceil(oldData.score / 68) === 3">
                        {{ level3.name }}
                      </h1>
                      <h1 slot="textCard__Headline" v-if="Math.ceil(oldData.score / 68) === 4">
                        {{ level4.name }}
                      </h1>
                      <h1 slot="textCard__Headline" v-if="Math.ceil(oldData.score / 68) === 5">
                        {{ level5.name }}
                      </h1>
                    </div>
                  </div>
                </md-card-content>
              </md-card>
            </div>
            <md-list>
              <div v-for="(item, key) in kirc" :key="key">
                <md-subheader class="md-primary md-title">{{ key }}</md-subheader>
                <div v-for="(question, index) in item" :key="question.name">
                  <div v-if="!question.optional">
                    <h4 class="singleQuestion">
                      {{ question.newidx + ". " + question.name }}
                    </h4>
                    <div style="display: flex; justify-content: space-between;">
                      <p v-if="!question.newAnswer">N/A</p>
                      <p v-else-if="!question.oldAnswer">{{ question.newAnswer.text }}</p>
                      <p v-else-if="question.newAnswer.text != question.oldAnswer.text" style="color: green; font-weight: bold;">{{ question.newAnswer.text }}</p>
                      <p v-else>{{ question.newAnswer.text }}</p>
                      <p style="margin-right: 20px;">{{ question.oldAnswer ?  question.oldAnswer.text : "N/A" }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </md-list>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>
  
<script>
  import json from "../../../../../static/data.json";
  import TextCard from "../../kirc/components/TextCard.vue";
  import RecCard from "../../kirc/components/RecommendationCard.vue";
  import ScoreCard from "../../kirc/components/ScoreCard.vue";
  import auth from "../../../../auth";
  import {
    postKIRCResult,
    getKIRC,
    getKIRCResult,
    saveResForUser,
  } from "../../../../api";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  export default {
    name: "KIRCCompare",
    components: {
      TextCard,
      RecCard,
      ScoreCard,
      Loading,
    },
    data() {
      return {
        loggedIn: auth.loggedIn(),
        places: json,
        bundesland: null,
        landkreis: null,
        keys: [],
        forTesting: false,
        error: null,
        rec: null,
        kirc: null,
        kircinstance: null,
        finalscore: 0,
        showProgress: false,
        active: null,
        recEvents: [],
        recTrainer: [],
        kircResText: "",
        resulttoken: null,
        answerHashMap: {},
        oldHash: "",
        oldLoaded: false,
        newLoaded: false,
        oldData: {
          score: 0,
          answers: []
        },
        newData: {
          score: 0,
          answers: []
        },
        answerData: {},
        level1: {
          name: "Novize",
          text: "Voraussetzungen für den Einsatz von KI-Anwendungen sind noch keine erfüllt. Es wurden noch keine KI-Anwendungsszenarien identifiziert. Das Thema KI wird im Unternehmen noch nicht wahrgenommen, auch über eine KI-Strategie hat man sich noch keine Gedanken gemacht. Daten werden in der Regel nur vereinzelt digital erfasst.",
        },
        level2: {
          name: "Erkunder",
          text: "Voraussetzungen für den Einsatz von KI-Anwendungen wurden identifiziert und Potenziale möglicher Anwendungen wurden erkannt. Die Mitarbeiter des Unternehmens beginnen sich für das Thema KI zu interessieren. Perspektivisch soll eine KI-Strategie eingeführt werden. Daten werden in der Regel noch unstrukturiert und dezentral erfasst. Notwendige Kompetenzen zum Umgang mit KI-Anwendungen wurden identifiziert.",
        },
        level3: {
          name: "Entdecker",
          text: "Maßnahmen zur Erfüllung der Voraussetzungen für die KI-Einführung wurden identifiziert. Konkrete Anwendungsszenarien wurden bereits erfasst und die Bereitschaft von Mitarbeitern KI-Projekte mitzutragen ist vereinzelt gegeben. Eine KI-Strategie ist in Planung. Daten werden bereits strukturiert, aber dezentral, erfasst. Die Mitarbeiter des Unternehmens werden beim Kompetenzaufbau im Bereich KI unterstützt.",
        },
        level4: {
          name: "Vorbereiter",
          text: "Maßnahmen, um die Voraussetzungen für KI-Anwendungen zu erfüllen wurden ergriffen. Es wurden konkrete Lösungsansätze für die identifizierten Anwendungsszenarien beschlossen. Die Bereitschaft der Mitarbeiter KI-Projekte mitzugestalten ist vorhanden und die Planung einer KI-Strategie ist abgeschlossen. Daten werden in der Regel zentral und größtenteils strukturiert erfasst. Ein erweitertes Angebot für den Kompetenzaufbau der Mitarbeiter ist vorhanden und wird gegebenenfalls durch die Akquise neuer Mitarbeiter unterstützt.",
        },
        level5: {
          name: "Anwender",
          text: "Die Voraussetzungen für den Einsatz von KI-Anwendungen sind erfüllt und die Umsetzung vereinzelter Anwendungsszenarien läuft. Die Mitarbeiter des Unternehmens sind motiviert KI-Projekte voranzutreiben. Die Umsetzung der KI-Strategie ist bereits angelaufen. Daten werden zentral gespeichert und es werden erste Analysen durchgeführt. Ein individueller Kompetenzaufbau im Bereich KI wird gefördert.",
        },
      };
    },
    updated() {
      //This is a good place for debugging.
    },
    created() {
      this.isLoading = true;
      //Load kirc questions
      getKIRC().then((res) => {
        this.kirc = new Object();
        this.kirc["Anwendungsbereiche und Technologien"] = res[
          "Anwendungsbereiche und Technologien"
        ].sort((a, b) => (a.index > b.index ? 1 : -1));
        this.kirc["Prozesse, Strategie und Organisation"] = res[
          "Prozesse, Strategie und Organisation"
        ].sort((a, b) => (a.index > b.index ? 1 : -1));
        this.kirc["Mitarbeiter"] = res["Mitarbeiter"].sort((a, b) =>
          a.index > b.index ? 1 : -1
        );
        this.kirc["Wirtschaftliche Perspektive, Produkte und Dienstleistungen"] =
          res["Wirtschaftliche Perspektive, Produkte und Dienstleistungen"].sort(
            (a, b) => (a.index > b.index ? 1 : -1)
          );
        this.kirc["Abschließende Fragen"] = res["Abschließende Fragen"].sort(
          (a, b) => (a.index > b.index ? 1 : -1)
        );
        // remove postleitzahl question
        const index = this.kirc["Abschließende Fragen"].findIndex(
          (x) => x.name === "Wie lautet die Postleitzahl Ihres Unternehmens?"
        );
        this.kirc["Abschließende Fragen"].splice(index, 1);

        let deepClone = JSON.parse(JSON.stringify(this.kirc));
        for (let prop in this.kirc) {
          for (let i = 0; i < this.kirc[prop].length; i++) {
            //For question with follow-up questions.
            if (this.kirc[prop][i].followup.includes("#")) {
              let parts = this.kirc[prop][i].followup.split("#");
              this.kirc[prop][i].followindices = [];
              for (let x = 0; x < parts.length; x++) {
                if (parts[x].length > 0) {
                  this.kirc[prop][i].followindices.push(parts[x]);
                  this.kirc[prop][parts[x] - 1].optional = true;
                }
              }
            }
          }
        }
        for (let prop in this.kirc) {
          let j = 0;
          for (let i = 0; i < this.kirc[prop].length; i++) {
            if (!this.kirc[prop][i].optional) {
              j++;
              this.kirc[prop][i].newidx = j;
            }
            //Sort the answers according to the index.
            this.kirc[prop][i].answers = this.kirc[prop][i].answers.sort((a, b) =>
              a.index > b.index ? 1 : -1
            );
          }
        }
        // Set kircinstance to sorted Kirc
        this.kircinstance = deepClone;
        for (let prop in this.kircinstance) {
          this.keys.push(prop);
          for (let i = 0; i < this.kircinstance[prop].length; i++) {
            if (this.kircinstance[prop][i].answers.length > 11) {
              this.kircinstance[prop][i].answers = [
                this.kircinstance[prop][i].answers[0],
              ];
            } else if (this.kircinstance[prop][i].answers.length === 1) {
              //console.log(this.kircinstance[prop][i].answers);
            } else if (this.kircinstance[prop][i].type == "multiple") {
              this.kircinstance[prop][i].answers = [];
            } else {
              this.kircinstance[prop][i].answers = [{}];
            }
          }
        }
        this.active = this.keys[0];
        this.isLoading = false;
      });
    },
    methods: {
      showComparison(){
        return this.oldLoaded && this.newLoaded
      },
      loadKIRCData() {
        //load new kirc answers
        this.getResult(this.$route.params.hash)

        // load old kirc answers
        this.getOldResult();
      },
      //load new kirc answers
      getResult(hash) {
        if (hash.length > 5) {
          this.isLoading = true;
          getKIRCResult(hash)
            .then((res) => {
              // somehow getKIRCResult does not throw an error if the hash is not found, so we have to check manually
              if(!res){
                this.error = "new";
                this.isLoading = false;
                return
              }
              this.newData.score = res.score;
              this.newData.answers = res.answerInstances;
              // connect answers to questions
              this.organizeAnswers(this.newData.answers, "new")
              this.isLoading = false;
              this.newLoaded = true;
            })
            .catch(() => {
              this.error = true;
              this.isLoading = false;
            });
        }
      },
      //load old kirc answers
      getOldResult() {
        if (this.oldHash.length > 5) {
          this.isLoading = true;
          getKIRCResult(this.oldHash)
            .then((res) => {
              // somehow getKIRCResult does not throw an error if the hash is not found, so we have to check manually
              if(!res){
                this.error = "old";
                this.isLoading = false;
                return
              }
              this.oldData.score = res.score;
              this.oldData.answers = res.answerInstances;
              // connect answers to questions
              this.organizeAnswers(this.oldData.answers, "old")
              this.isLoading = false;
              this.oldLoaded = true;
            })
            .catch(() => {
              this.error = true;
              this.isLoading = false;
            });
        }
      },
      // connect answers to questions
      organizeAnswers(answers, type) {
        // build "hashmap" of all answers
        for (let cat in this.kirc) {
          for (let question in this.kirc[cat]) {
            for (let answerInd in this.kirc[cat][question].answers) {
              let answer = this.kirc[cat][question].answers[answerInd]
              this.answerHashMap[answer.hash] = {
                name: answer.name,
                text: answer.text,
                answerIndex: answerInd,
                category: cat,
                question: this.kirc[cat][question].name,
                questionHash: this.kirc[cat][question].hash,
                questionIndex: question
              }
            }
          }
        }
        // add answerHash to each question
        for (let answer in answers) {
          let hash = answers[answer].answerhash
          if (this.answerHashMap[hash]) {
            let a = this.answerHashMap[hash]
            this.kirc[a.category][a.questionIndex][type + "Answer"] = a
          }
        }
        // fix for reactivity system not working for nested changes in vue2
        let b = this.kirc
        this.kirc = {}
        this.kirc = b
      }
    },
  };
</script>
  
  
<style>
  /* TODO: Adjust this */
  /* Global Styles */
  /* Dropdown Menu Wrapper */
  .md-menu-content {
    min-height: auto;
    /* max-width: 300px; */
    max-height: 100vh;
  }
  .md-checkbox .md-checkbox-label {
    height: 100% !important;
  }
</style>
  
  
<style scoped>
  /* Local Styles */
  .kircWrapper {
    margin-top: -20px;
    margin-bottom: -100px;
    padding: 4em 4em 8em 4em;
    min-height: 1000px;
  }
  .md-steppers.md-vertical .md-stepper-content {
    padding: 0px !important;
  }
  .particles {
    text-align: center;
    color: #2c3e50;
    background-image: url("../../../../assets/particle-bg-min.png");
    background-color: #641b1a;
    box-sizing: border-box;
    background-repeat: repeat;
    background-size: auto;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .answerBoxes {
    padding-bottom: 2em;
    padding-right: 12px;
  }
  .kiReadinessLevel__H1 {
    text-align: center !important;
    color: #333;
  }
  .kiReadinessLevel__H1.left-align {
    text-align: left !important;
  }
  .CustomCard {
    border-radius: 15px;
    margin: 18px;
    padding: 0px 18px;
    box-shadow: 0 0.6px 2.2px rgba(0, 0, 0, 0.014), 0 1.3px 5.3px rgba(0, 0, 0, 0.02), 0 2.5px 10px rgba(0, 0, 0, 0.025), 0 4.5px 17.9px rgba(0, 0, 0, 0.03), 0 8.4px 33.4px rgba(0, 0, 0, 0.036), 0 20px 80px rgba(0, 0, 0, 0.05);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .progessWrapper {
    position: relative;
  }
  .finalScoreWrapper {
    position: absolute;
    top: 30%;
    right: 25%;
    text-align: center;
  }
  .mainFormCard {
    max-width: 2000px;
    margin: 0 auto;
    /* padding: 16px; */
  }
  .questionWrapper {
    background-color: #f1f3f6;
    padding: 2em;
    margin-bottom: 2em;
    border-radius: 6px;
  }
  .singleQuestion {
    margin: 1em 0px 0em 0px;
  }
  .headlineWrapper {
    background-color: #1a1a1a;
    padding: 1em;
    margin: -16px -16px 16px -16px;
  }
  .mainHeadline {
    color: #fff;
    font-size: 34px;
    line-height: 40px;
  }
  .subHeading {
    font-weight: 500;
  }
  .nextBtn {
    margin-top: 24px;
  }
  .missedQuestions {
    font-size: 16px;
    font-weight: 500;
    color: #000;
    background-color: #eb8f8f;
    margin: 18px;
    padding: 18px;
    line-height: 1.6em;
    border-radius: 10px;
  }
  .missedQuestions ul li {
    color: green;
  }
  .CTA {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
    margin-top: 36px 18px 18px 18px;
    height: 60px;
    width: 180px;
    border-radius: 10px;
    text-transform: none;
  }
  .CTA.Secondary {
    color: #9a9da8;
  }
  .Secondary--LoggedIn {
    color: #9a9da8;
  }
  .Secondary--LoggedIn:hover {
    margin-left: -50px;
    color: #000000;
    background-color: rgba(240, 248, 255, 0);
  }
  .stickyHeading__Wrapper {
    width: 100%;
    position: sticky;
    top: 0;
    padding: 12px 16px;
    z-index: 333;
    background-color: #fff;
    display: flex;
  }
  .resultAction-Wrapper {
    padding-right: 30px;
    padding-bottom: 12px;
  }
  .ki-cell-small {
    width: 25% !important;
  }
  .ki-cell-large {
    width: 50% !important;
  }
  .no-link {
    text-decoration: none !important;
    color: black !important;
  }
  .confirmationWrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .viewport {
    width: 100%;
    max-width: 100%;
    display: inline-block;
    vertical-align: top;
    overflow: auto;
  }
  .questionRow {
    width: 100%;
  }
  /* Responsive */
  @media (max-width: 1120px) {
    .kircWrapper {
      margin-top: -20px;
      margin-bottom: -100px;
      padding: 3em 1em 6em 1em;
      min-height: 1000px;
    }
  }
  @media (max-width: 600px) {
    .answerBoxes {
      padding-bottom: 0em;
    }
    .kircWrapper {
      margin-top: -20px;
      margin-bottom: -100px;
      padding: 0em 0em 3em 0em;
      min-height: 1000px;
    }
  }
</style>
  
  
  
  
  


// WEBPACK FOOTER //
// src/components/company/kirc/compare/kirccompare.vue